import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'
import InputTextSF from '../../../widgets/form/InputTextSF'

const PF2StatusUpdateModalUI = ({
    context, successMsg, errorList, setErrorList,
    updateMode, submitted, onSubmit, onCancelClick,
    processingFeeStatus, onProcessingFeeStatusChange, processingFeeStatusError, setProcessingFeeStatusError, processingFeeStatusList,
    tdsAmount, onTdsAmountChange, tdsAmountError, setTdsAmountError
}) =>
    <ModalFormUI
        context={context}
        titleLabel='Processing fee status update'
        buttonLabel='Update'
        cancelLabel='Cancel'
        isOpen={updateMode}
        onRequestClose={onCancelClick}
        successMsg={successMsg}
        errorList={errorList}
        setErrorList={setErrorList}
        onSubmit={onSubmit}
        busy={submitted}
    >
        < InputSelectSF type='select' name='processingFeeStatus' label='Processing fee status'
            value={processingFeeStatus} onChange={onProcessingFeeStatusChange} optionList={processingFeeStatusList}
            error={processingFeeStatusError} setError={setProcessingFeeStatusError}
        />

        <InputTextSF type='text' name='tdsAmount' label='TDS amount' maxLength={10}
            value={tdsAmount} onChange={onTdsAmountChange}
            error={tdsAmountError} setError={setTdsAmountError}
        />
    </ModalFormUI>

export default PF2StatusUpdateModalUI
